import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/admin-groups-list.reducer";
import {EffectsModule} from "@ngrx/effects";
import {AdminGroupsListEffects} from "./core/admin-groups-list.effects";
import {AdminGroupsListScreenComponent} from './screen/admin-groups-list-screen.component';
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {
  GroupInformationTableComponent
} from "./components/tables/group-information-table/group-information-table.component";
import {
  GroupInformationFilterComponent
} from "./components/filters/group-information-filter/group-information-filter.component";
import {ParticipantOrCaregiverInformationFilterComponent} from './components/filters/participant-or-caregiver-information-filter/participant-or-caregiver-information-filter.component';
import {ParticipantOrCaregiverInformationTableComponent} from './components/tables/participant-or-caregiver-information-table/participant-or-caregiver-information-table.component';
import {ParticipantWeightInformationFilterComponent} from './components/filters/participant-weight-information-filter/participant-weight-information-filter.component';
import {ParticipantWeightInformationTableComponent} from './components/tables/participant-weight-information-table/participant-weight-information-table.component';
import { ParticipantBehaviourInformationFilterComponent } from './components/filters/participant-behaviour-information-filter/participant-behaviour-information-filter.component';
import { ParticipantBehaviourInformationTableComponent } from './components/tables/participant-behaviour-information-table/participant-behaviour-information-table.component';


@NgModule({
  declarations: [
    AdminGroupsListScreenComponent,
    GroupInformationTableComponent,
    GroupInformationFilterComponent,
    ParticipantOrCaregiverInformationFilterComponent,
    ParticipantOrCaregiverInformationTableComponent,
    ParticipantWeightInformationFilterComponent,
    ParticipantWeightInformationTableComponent,
    ParticipantBehaviourInformationFilterComponent,
    ParticipantBehaviourInformationTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.admin-groups-list', reducer),
    EffectsModule.forFeature(
      [AdminGroupsListEffects]
    ),
    MaterialModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    InfiniteScrollModule,
  ]
})
export class AdminGroupsListModule {
}
